<div class="worklog-container">
  <!-- Loading overlay -->
  <div *ngIf="isLoading" class="loading-overlay">
    <div class="loading-content">
      <img src="assets/hm-loading-new.gif" alt="Loading" class="loading-gif">
      <p class="loading-text mat-h2">Waiting for data from the eCase server...</p>
    </div>
  </div>

  <!-- Header with title and date picker -->
  <div class="worklog-header" *ngIf="!isLoading">
    <h1 class="worklog-title">Worklog Editor</h1>
    <mat-form-field appearance="outline" class="date-picker">
      <mat-label>Select Date</mat-label>
      <input matInput [matDatepicker]="picker" [value]="currentDate" (dateChange)="onDateChange($event)">
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="table-container" *ngIf="!isLoading">
    <table mat-table [dataSource]="flattenedTableData" class="unified-table">
      <!-- Resident Column -->
      <ng-container matColumnDef="resident">
        <th mat-header-cell *matHeaderCellDef>Resident</th>
        <td mat-cell *matCellDef="let row">
          <div class="table-resident-cell">
            <img [src]="getResidentPhotoUrl(row.resident_id)"
                 [alt]="row.resident_name"
                 class="resident-photo"
                 (error)="handleImageError($event)">
            <span class="resident-name">{{ row.resident_name }}</span>
          </div>
        </td>
      </ng-container>

      <!-- Chart/Activity Column -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Chart/Activity</th>
        <td mat-cell *matCellDef="let row">
          <div class="table-chart-cell">
            <mat-icon>{{ row.chart_id ? 'assessment' : 'event_note' }}</mat-icon>
            <span>{{ row.description }}</span>
          </div>
        </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Chart Status</th>
        <td mat-cell *matCellDef="let row">
          <a *ngIf="row.chart_id"
             [href]="getEcaseChartUrl(row)"
             target="_blank"
             class="chart-status-link">
            <mat-chip [color]="row.is_chart_active ? 'primary' : 'warn'">
              <mat-icon>open_in_new</mat-icon>
              {{ row.is_chart_active ? 'Active' : 'Inactive' }}
            </mat-chip>
          </a>
          <span *ngIf="!row.chart_id" class="no-chart-text">-</span>
        </td>
      </ng-container>

      <!-- Activities Column -->
      <ng-container matColumnDef="activities">
        <th mat-header-cell *matHeaderCellDef>Activities</th>
        <td mat-cell *matCellDef="let row">
          <div class="table-activities">
            <mat-chip-set>
              <mat-chip *ngFor="let activity of row.activities"
                        [color]="getStatusColor(activity.status)">
                <mat-icon>{{ getStatusIcon(activity.status) }}</mat-icon>
                {{ activity.time || 'No time' }}
              </mat-chip>
            </mat-chip-set>
          </div>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row">
          <div class="table-actions">
            <button mat-icon-button
                    color="warn"
                    [matTooltip]="row.chart_id ? 'Delete chart activities' : 'Delete recurring activities'"
                    (click)="onDeleteActivities(row)">
              <mat-icon>delete_sweep</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['resident', 'description', 'status', 'activities', 'actions']; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: ['resident', 'description', 'status', 'activities', 'actions']"></tr>
    </table>
  </div>
</div>
